import {BaseCachedService} from "./Core/BaseCachedService";

class TagService extends BaseCachedService {
    get Url() { return super.Url + "/tags"; }
    get ModelName() { return "Tag"; }
    get PrimaryKeyProperty() { return "tagId"; }

    get TitleProperty() {
        return super.TitleProperty;
    }
}

export const service = new TagService();

